'use strict';

var insertRow = require('./changes/insertRow');

/**
 * Insert a new row when pressing "Enter"
 */
function onEnter(event, change, opts) {
  event.preventDefault();

  return insertRow(opts, change);
}

module.exports = onEnter;


//////////////////
// WEBPACK FOOTER
// ../node_modules/slate-edit-table/dist/onEnter.js
// module id = 1168
// module chunks = 0